import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"microphone"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M6 7C6 4.23858 8.23858 2 11 2H13C15.7614 2 18 4.23858 18 7V13C18 13.3425 17.9656 13.6769 17.9 14C17.4367 16.2822 15.419 18 13 18C12.219 18 11.781 18 11 18C8.58104 18 6.56329 16.2822 6.10002 14C6.03443 13.6769 6 13.3425 6 13V7Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M6 7C6 4.23858 8.23858 2 11 2H13C15.7614 2 18 4.23858 18 7V13C18 13.3425 17.9656 13.6769 17.9 14C17.4367 16.2822 15.419 18 13 18C12.219 18 11.781 18 11 18C8.58104 18 6.56329 16.2822 6.10002 14C6.03443 13.6769 6 13.3425 6 13V7Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M6 7C6 4.23858 8.23858 2 11 2H13C15.7614 2 18 4.23858 18 7V13C18 13.3425 17.9656 13.6769 17.9 14C17.4367 16.2822 15.419 18 13 18C12.219 18 11.781 18 11 18C8.58104 18 6.56329 16.2822 6.10002 14C6.03443 13.6769 6 13.3425 6 13V7Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 18V21M7 21H17M6.5 14H9M6.5 7H9M6.5 10.5H9M15 14H17.5M15 7H17.5M15 10.5H17.5M6 7V13C6 13.3425 6.03443 13.6769 6.10002 14C6.56329 16.2822 8.58104 18 11 18C11.781 18 12.219 18 13 18C15.419 18 17.4367 16.2822 17.9 14C17.9656 13.6769 18 13.3425 18 13V7C18 4.23858 15.7614 2 13 2H11C8.23858 2 6 4.23858 6 7Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Microphone = Vue.extend<IconProps>({
  name: 'MicrophoneIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'microphone',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Microphone;
